const namespace = "retailer-search";
const formNamespace = `${namespace}-form`;
const resultsNamespace = `${namespace}-results`;

const formButtonId = `${formNamespace}-button`;

const resultsListPanelId = `${resultsNamespace}-list`;
const resultsErrorPanelId = `${resultsNamespace}-error`;

const visibleCSSClass = "visible";
const hiddenCSSClass = "hidden";

let form = document.forms.namedItem(`${formNamespace}-form`);
form.addEventListener("submit", submit_retailer_search_from);

function submit_retailer_search_from (ev) {
    ev.preventDefault();

    let formData = new FormData(form);

    let requestBody = {};
    if(!formData.has("postalCode")) {
        return;
    }
    requestBody["plz"] = formData.get("postalCode");

    if(formData.has("url")) {
        requestBody["url"] = formData.get("url");
    }

    let req = new XMLHttpRequest();

    req.onreadystatechange = function () {
        switch (this.readyState) {
            case 1:
                onLoad(this);
                break;
            case 4:
                onLoadEnd(this);
                break;
        }
    };

    req.open("POST", "/wp-json/retailers/v1", true);
    req.setRequestHeader("Content-Type", "application/json");
    req.send(JSON.stringify(requestBody));
}

function onLoad(event) {
    let button = document.getElementById(formButtonId);
    let loadingSpinner = document.getElementById(`${formNamespace}-loadingSpinner`);
    let resultsPanel = document.getElementById(resultsNamespace);

    button.disabled = true;
    setVisibility(loadingSpinner, true);
    setVisibility(resultsPanel, false);
}

function onLoadEnd(event) {
    let button = document.getElementById(formButtonId);
    let loadingSpinner = document.getElementById(`${formNamespace}-loadingSpinner`);
    let resultsPanel = document.getElementById(resultsNamespace);

    button.disabled = false;
    setVisibility(loadingSpinner, false);
    setVisibility(resultsPanel, true);

    let jsonResponse = JSON.parse(event.responseText);
    if (event.status == 200) {
        renderAndShowResult(jsonResponse);
    } else {
        renderError(jsonResponse);
    }
}

function renderAndShowResult(jsonArray) {

    let resultsListPanel = document.getElementById(resultsListPanelId);
    let resultsErrorPanel = document.getElementById(resultsErrorPanelId);

    setVisibility(resultsListPanel, true);
    setVisibility(resultsErrorPanel, false);

    resultsListPanel.innerText = "";

    jsonArray.forEach(function (jsonRetailer) {
        resultsListPanel.innerHTML += hslr_retailer_search_detail_template(jsonRetailer);
    });
}

function renderError(jsonResponse) {

    let resultsListPanel = document.getElementById(resultsListPanelId);
    let resultsErrorPanel = document.getElementById(resultsErrorPanelId);
    let resultsErrorDetailsPanel = document.getElementById(`${resultsNamespace}-error-detail`);

    setVisibility(resultsListPanel, false);
    setVisibility(resultsErrorPanel, true);

    resultsErrorDetailsPanel.innerText += jsonResponse.title;
}

function setVisibility(htmlObject, visible) {
    if (visible) {
        htmlObject.classList.remove(hiddenCSSClass);
        htmlObject.classList.add(visibleCSSClass);
    } else {
        htmlObject.classList.remove(visibleCSSClass);
        htmlObject.classList.add(hiddenCSSClass);
    }
}